jQuery(document).ready(function ($) {

    function dynamicMenu() {
        const parentEl = $(".dynamic-mobile-nav"),
               links = parentEl.find(".menu a");
        parentEl.toggleClass("active");
    }

    // Dynamic nav (mobile menu)

    const redlumDynamenu = $('.dynamic-mobile-nav .menu'),
        links = redlumDynamenu.find('.click-child'),
        triggers = redlumDynamenu.find('.menu-item-has-children > a'),
        backItem = redlumDynamenu.find('.back-item');


    links.each(function() {
        $(this).parent().prev().clone().appendTo($(this));
    });

    triggers.each(function() {
        $(this).on("click", function(e){
            e.preventDefault();
            $(this).next().addClass('open')
        });
    });

    backItem.each(function() {
        $(this).on("click", function(e){
            e.preventDefault();
            $(this).parent().removeClass('open');
        });
    });

    // item box

    $('.item.box').on("click", function(){
        window.location.href = $(this).find('a')[0].href;
    });

    $('.item.box').hover(function() {
        if ($(this).find('a')[0].href){
            $(this).addClass('hoverbox');
        }
    });


    // langmenu

    $(".lang").click(function (e) {
        e.preventDefault();
        $('.language-nav').toggleClass("active");
    });

    $(".language-nav .close-menu-button").click(function (e) {
        e.preventDefault();
        $('.language-nav ').toggleClass("active");
    });

    // searchscreen

    $(".searchbtn").click(function (e) {
        e.preventDefault();
        $('.seach-overlay').toggleClass("active");
    });

    $(".seach-overlay .close-menu-button").click(function (e) {
        e.preventDefault();
        $('.seach-overlay').toggleClass("active");
    });

    // remove prefill value

    $("#s").click(function (e) {
        e.preventDefault();
        $(this).attr('value','')
    });

    // Close mobile menu on click
    $(".dynamic-mobile-nav .close-menu-button").click(function (e) {
         e.preventDefault();
        $(".dynamic-mobile-nav").toggleClass("active");

        const allSubs = $(".dynamic-mobile-nav").find('.sub');

        allSubs.each(function() {
            if ($(this).hasClass("open")){
                $(this).toggleClass("open");
            }
        });

    });

    // Close mobile menu on click
    $(".mobile-nav > .close-menu-button").click(function (e) {
        e.preventDefault();
        $(".mobile-nav").toggleClass("active");
    });

    // Open mobile menu on click
    $(".mobile-menu-button .menu-icon").click(function (e) {
            e.preventDefault();

            if (jQuery(window).width() <= 767){
                dynamicMenu();
            }else{
                $(".mobile-nav").toggleClass("active");
            }
    });

    // Close mobile menu on click
    $(".mobile-nav .close-menu-button").click(function (e) {
        e.preventDefault();
        $(".mobile-nav").toggleClass("active");
    });

    // Close mobile menu on outside click (click on overlay)
    $(".active-menu-overlay").click(function (e) {
        e.preventDefault();
        $(".mobile-nav").toggleClass("active");
    });

    // Expand child ul on click child indicator
    $(".mobile-nav .child-indicator").click(function (e) {
        e.preventDefault();
        $(this).parent("li").toggleClass("active-submenu");
    });

    // Expand child ul on click child indicator
    $(".read").click(function (e) {
        e.preventDefault();
        $('#readspeaker_button1').toggleClass('show');
        $(this).toggleClass('active');
    });


    $(".dynamic-mobile-nav .read").click(function (e) {
        e.preventDefault();
        $(".dynamic-mobile-nav").removeClass("active");
    });


    // Make header sticky after scrolling 'x' pixels - styling is done via 'scroll-active' class (header file)

    var iScrollPos = 0;

    $(window).bind('scroll', function() {

        var iCurScrollPos = $(this).scrollTop();
        if (iCurScrollPos > iScrollPos) {

            // $("body").removeClass("scroll-active");
            // $(".header").fadeOut( "fast", function() {
            //     $(".header").removeClass("scroll-active");
            // });


        } else {
            $(".header").fadeIn( "fast", function() {
                $(".header").addClass("scroll-active");
                $("body").addClass("scroll-active");
                $("#readspeaker_holder.active.clone").addClass("scroll-active");

                if ($("#readspeaker_holder.active.clone").length > 0 ) {
                    $(".header").addClass("rsavail");
                }


                if (iCurScrollPos == 0) {
                    $("body").removeClass("scroll-active");
                    $(".header").removeClass("scroll-active");
                    $(".header").removeClass("rsclone");
                    $("#readspeaker_holder.active.clone").removeClass("scroll-active");


                    if ($("#readspeaker_holder.active.clone").length > 0 ) {
                        $(".header").removeClass("rsavail");
                    }

                }

            });
        }

        iScrollPos = iCurScrollPos;

    });

    // vacancy_form

    if($('.vacancy_form').length > 0) {
        $('#input_2_9').val($('h1')[0].innerHTML);
    }

    // course_form

    if($('.course_form').length > 0) {
        $('#input_4_10').val($('h1')[0].innerHTML);
    }

    if($('body.home .article-content').length > 0) {
        var firstRowBefore = $('body.home .article-content div').first();
        firstRowBefore.addClass('simplerow');
    }

    // Point map to 

    function GetURLParameter(sParam) {
        var sPageURL = window.location.search.substring(1);
        var sURLVariables = sPageURL.split('&');
        for (var i = 0; i < sURLVariables.length; i++)
        {
            var sParameterName = sURLVariables[i].split('=');
            if (sParameterName[0] == sParam)
            {
                return sParameterName[1];
            }
        }
    }​

    if (window.location.pathname === "/locaties/") {

        if (GetURLParameter('pc') && GetURLParameter('radius')){

            var postalcode = GetURLParameter('pc');
            var radius = GetURLParameter('radius');

        }else{
            var postalcode = '1012 JL';
            var radius = '75';
        }

        $('#addressInput_1').val(postalcode);
        $('.wpgmza_sl_radius_select').val(radius);
        $('.wpgmza_sl_search_button_1').trigger("click");

    }




});



